import { Injectable, inject } from '@angular/core';
import { UsersDataService } from './feature-users.dataservice.service';
import { UserDto } from './models';

@Injectable({ providedIn: 'root' })
export class UsersService {
  private usersDataService = inject(UsersDataService);
  // private nomohPermissionService = inject(NomohPermissionService); // TODO: Implementar quando dispon�vel

  //  PRINC�PIO KISS: Component injeta DataService diretamente para signals
  //  Service apenas para business logic com valida��es

  async carregarUsers(): Promise<void> {
    // Business logic: Validar permiss�o (SEMPRE no nomoh-administrador)
    // await this.nomohPermissionService.validarPermissao('listar_usuarios');

    return this.usersDataService.carregarUsers();
  }

  async buscarUsers(nome?: string, email?: string): Promise<void> {
    // await this.nomohPermissionService.validarPermissao('listar_usuarios');

    return this.usersDataService.buscar(nome, email);
  }

  async proximaPagina(): Promise<void> {
    // Navega��o simples - sem valida��o adicional necess�ria
    return this.usersDataService.proximaPagina();
  }

  async paginaAnterior(): Promise<void> {
    return this.usersDataService.paginaAnterior();
  }

  async irParaPagina(pagina: number): Promise<void> {
    return this.usersDataService.irParaPagina(pagina);
  }

  async resetarSenha(userId: string): Promise<void> {
    // Business logic: Validar permiss�o cr�tica
    // await this.nomohPermissionService.validarPermissao('resetar_senha_usuario');
    // TODO: Implementar chamada para API de reset de senha
    // return this.usersDataService.resetarSenha(userId);
  }

  // M�todos adicionais de business logic conforme necess�rio
  async excluirUser(userId: string): Promise<boolean> {
    // await this.nomohPermissionService.validarPermissao('excluir_usuario');

    // TODO: Implementar lógica de exclusão
    return true;
  }

  async atualizarUser(user: UserDto): Promise<boolean> {
    // await this.nomohPermissionService.validarPermissao('editar_usuario');

    // TODO: Implementar lógica de atualização
    return true;
  }
}
